import { getSamsaraGpsCoordinatesApi, getSamsaraTrucksApi } from 'api/samsara';

export const GET_SAMSARA_GPS_REQUEST = 'GET_SAMSARA_GPS_REQUEST';
export const GET_SAMSARA_GPS_SUCCESS = 'GET_SAMSARA_GPS_SUCCESS';
export const GET_SAMSARA_GPS_FAILURE = 'GET_SAMSARA_GPS_FAILURE';
export const GET_SAMSARA_TRUCKS_REQUEST = 'GET_SAMSARA_TRUCKS_REQUEST';
export const GET_SAMSARA_TRUCKS_SUCCESS = 'GET_SAMSARA_TRUCKS_SUCCESS';
export const GET_SAMSARA_TRUCKS_FAILURE = 'GET_SAMSARA_TRUCKS_FAILURE';

export const SET_SAMSARA_FILTER = 'SET_SAMSARA_FILTER';
export const CLEAR_SAMSARA_STATE = 'CLEAR_SAMSARA_STATE';

export const getSamsaraTrucks = () => async (dispatch) => {
  dispatch({ type: GET_SAMSARA_TRUCKS_REQUEST });
  try {
    const data = await getSamsaraTrucksApi();
    console.log('TRUCKS SUCCESS:', data);
    dispatch({ type: GET_SAMSARA_TRUCKS_SUCCESS, payload: data });
  } catch (error) {
    console.error('TRUCKS ERROR:', error);
    dispatch({ type: GET_SAMSARA_TRUCKS_FAILURE, payload: error.message });
  }
};

export const getSamsaraGpsCoordinates = () => async (dispatch) => {
  console.log(' Starting getSamsaraGpsCoordinates... Endpoint: /SamsaraGpsData');
  dispatch({ type: GET_SAMSARA_GPS_REQUEST });
  try {
    const data = await getSamsaraGpsCoordinatesApi();
    console.log('GPS SUCCESS (contains truck data):', data);
    dispatch({ type: GET_SAMSARA_GPS_SUCCESS, payload: data });
  } catch (error) {
    console.error('GPS ERROR:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      data: error.response?.data
    });
    dispatch({ type: GET_SAMSARA_GPS_FAILURE, payload: error.message });
  }
};

export const setSamsaraFilter = (filter) => ({
  type: SET_SAMSARA_FILTER,
  payload: filter
});

export const clearSamsaraState = () => ({
  type: CLEAR_SAMSARA_STATE
});
